import {GetProgressParams} from 'domain/usecases/private/profile/get-progress';
import {makeGetProgress} from 'main/factories/usecases/private/profile/get-progress';

export async function getProgress(params: GetProgressParams) {
	const response = await makeGetProgress().get(params);

	return response;
}
